import BaseBar from "../../sisu/chart/BaseBar.sisu";

const NeoBar = BaseBar

export default NeoBar